import React from "react";
import { useFormik } from "formik";
import { StateContext } from "state.js";
import { usePostContact } from "hooks";
import { Danger, InputDate, InputText } from "components";

// Creative Tim
import GridContainer from "components-material-ui/Grid/GridContainer.js";
import GridItem from "components-material-ui/Grid/GridItem.js";
import Button from "components-material-ui/CustomButtons/Button.js";
import Card from "components-material-ui/Card/Card.js";
import CardBody from "components-material-ui/Card/CardBody.js";

// Material UI
import Box from "@material-ui/core/Box";


export function FormContact(props) {
    const State = React.useContext(StateContext);
    const [token] = React.useState(State?.user?.value?.token);
    const [requestBody, setRequestBody] = React.useState();
    const { response, error, isLoading } = usePostContact(token, requestBody, props.id);

    const boxSettings = { mb: 6 };

    const formik = useFormik({
        initialValues: {
          id: props.id ? props.id : "",
          name: props.name ? props.name : "",
          role: props.role ? props.role : "",
          organization: props.organization ? props.organozation : "",
        },
        validate: (values) => {
          const errors = {};
          if (!values.name) errors.name = "Required";
    
          return errors;
        },
        onSubmit: (values) => {
          const body = {
            id: values.id,
            name: values.name,
            role: values.role,
            organization: values.organization,
          };
          setRequestBody(body)
        },
      });

    const HelperText = {
      name: formik.errors.name && formik.submitCount ? <Danger>{formik.errors.name}</Danger> : null,
      role: formik.errors.role && formik.submitCount ? <Danger>{formik.errors.role}</Danger> : null,
      organization: formik.errors.organization && formik.submitCount ? <Danger>{formik.errors.organization}</Danger> : null,
    }

    React.useEffect(() => {
      if (response) {
        props.setContact(response);
      }
    }, [response]);

    return (
        <React.Fragment>
            <>
              <form autoComplete="off">
                <Card>
                  <CardBody>
                    <h3>{props?.name}</h3>
                    <Box {...boxSettings}>
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                          <InputText
                            helperText={HelperText["name"]}
                            label="Name"
                            name="name"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                          <InputText
                            helperText={HelperText["role"]}
                            label="Role"
                            name="role"
                            value={formik.values.role}
                            onChange={formik.handleChange}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                          <InputText
                            helperText={HelperText["organization"]}
                            label="Organization"
                            name="organization"
                            value={formik.values.organization}
                            onChange={formik.handleChange}
                          />
                        </GridItem>
                      </GridContainer>
                    </Box>
                    <Box {...boxSettings}>
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={4}></GridItem>
                        <GridItem xs={12} sm={12} md={4}>
                          <Button color="info" fullWidth onClick={formik.handleSubmit}>
                            Submit
                          </Button>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={4}></GridItem>
                      </GridContainer>
                    </Box>
                  </CardBody>
                </Card>
              </form>
            </>
        </React.Fragment>
    );
}
